import React from 'react';
import { ITooltipData } from 'components/ModalTooltip/types';

export default function ModalTooltipComponent(props: ITooltipData) {
  // Destructure tooltipData
  const {
    alt,
    cap,
    disableTouchEvents,
    name,
    description,
    level,
    image,
    secondaryDescription,
    smallButtons,
    imagePath,
    onRequestClose,
  } = props;

  return (
    <div
      className="tooltip--item-modal"
      style={{ touchAction: disableTouchEvents ? 'none' : undefined }}
    >
      {image && (
        <div
          className="icon icon--circular tooltip__icon"
        >
          <img
            alt={alt}
            src={imagePath}
          />
        </div>
      )}
      <div className={Image ? 'tooltip__desc' : 'tooltip__desc__noImage'}>
        <span className="item__name" dangerouslySetInnerHTML={{ __html: name ?? '' }} />
        {' '}
        <span className="item__value">
          {level}
          {cap !== undefined && ` / ${cap}`}
        </span>
        <p dangerouslySetInnerHTML={{ __html: description ?? '' }} />
        <div
          className="tooltip__secondary-description"
          dangerouslySetInnerHTML={{ __html: secondaryDescription ?? '' }}
        />
        {smallButtons && (
          <div className="tooltip__buttons">
            {smallButtons.map((item, i) => (
              <button
                key={i}
                className="button button--primary button--sm button--tooltip"
                onClick={() => {
                  // Call onRequestClose, if we received it
                  onRequestClose?.();
                  item.action();
                }}
              >
                {item.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}